import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { useAuth } from '../../contexts/AuthContext';
import {  deleteSimulation } from '../../services/simulacaoService';
import {  subscribeClientsByRole } from '../../services/clientService';
import { subscribeSimulationsByRole } from '../../services/simulacaoService';
import { useUserProfile } from '../../contexts/UserContext';

const AVATAR_COLORS = ['#3B82F6', '#8B5CF6', '#14B8A6', '#F43F5E', '#F97316', '#EC4899', '#6366F1', '#0EA5E9'];

function getColor(name) {
  let hash = 0;
  for (let i = 0; i < (name || '').length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function getIniciais(name) {
  return (name || 'S').split(' ').map((p) => p[0]).join('').slice(0, 2).toUpperCase();
}

function formatDate(timestamp) {
  if (!timestamp) return '—';
  const d = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const now = new Date();
  const diff = now - d;
  if (diff < 86400000) return `Hoje, ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
  if (diff < 172800000) return `Ontem, ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
  return d.toLocaleDateString('pt-BR');
}

export default function SimulacoesSalvasPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [simulations, setSimulations] = useState([]);
  const [clients, setClients] = useState([]);
  const [busca, setBusca] = useState('');
const { profile } = useUserProfile();
  useEffect(() => {
    if (!user) return;
    const unsub1 = subscribeSimulationsByRole(profile, setSimulations);
    const unsub2 = subscribeClientsByRole(profile, setClients);
    return () => { unsub1(); unsub2(); };
  }, [profile]);

  const getClientName = (clientId) => {
    if (!clientId) return 'Simulação avulsa';
    const c = clients.find((cl) => cl.id === clientId);
    return c?.nome || 'Cliente removido';
  };

  const filtered = simulations.filter((sim) => {
    const clientName = getClientName(sim.clientId);
    const bancoNames = (sim.bancos || []).map((b) => b.nome).join(' ');
    const searchStr = `${clientName} ${bancoNames} ${sim.valorFinanciado || ''}`.toLowerCase();
    return searchStr.includes(busca.toLowerCase());
  });

  const handleDelete = async (simId) => {
    if (!window.confirm('Excluir esta simulação?')) return;
    await deleteSimulation(simId);
  };

  const tdStyle = { padding: '14px 20px', fontSize: '0.82rem', borderBottom: '1px solid var(--border)' };

  return (
    <>
      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 14, marginBottom: 24 }}>
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '16px 18px' }}>
          <div style={{ fontSize: '1.4rem', fontWeight: 700, color: 'var(--accent)' }}>{simulations.length}</div>
          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 2 }}>Total de Simulações</div>
        </div>
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '16px 18px' }}>
          <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#3B82F6' }}>
            {simulations.filter((s) => s.clientId).length}
          </div>
          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 2 }}>Vinculadas a Clientes</div>
        </div>
        <div style={{ background: 'var(--white)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '16px 18px' }}>
          <div style={{ fontSize: '1.4rem', fontWeight: 700, color: '#8B5CF6' }}>
            {simulations.filter((s) => !s.clientId).length}
          </div>
          <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 2 }}>Simulações Avulsas</div>
        </div>
      </div>

      {/* Table */}
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div className="page-toolbar" style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 20px', borderBottom: '1px solid var(--border)', gap: 10, flexWrap: 'wrap',
        }}>
          <input
            type="text" placeholder="Buscar por cliente, banco ou valor..."
            value={busca} onChange={(e) => setBusca(e.target.value)}
            style={{
              padding: '8px 14px', border: '1.5px solid var(--border)', borderRadius: 'var(--radius-xs)',
              fontFamily: 'var(--font)', fontSize: '0.82rem', flex: 1, minWidth: 0, outline: 'none',
            }}
          />
          <Button variant="accent" onClick={() => navigate('/simulador')}>
            ⚡ Nova Simulação
          </Button>
        </div>

        <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 700 }}>
          <thead>
            <tr>
              {['Cliente', 'Valor Financiado', 'Prazo', 'Bancos Simulados', 'Melhor Banco', 'Data', ''].map((h) => (
                <th key={h} style={{
                  textAlign: 'left', fontSize: '0.68rem', fontWeight: 600, color: 'var(--text-muted)',
                  textTransform: 'uppercase', letterSpacing: '0.05em', padding: '10px 20px',
                  background: 'var(--surface)', borderBottom: '1px solid var(--border)',
                }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr>
                <td colSpan={7} style={{ ...tdStyle, textAlign: 'center', color: 'var(--text-muted)', padding: 40 }}>
                  {busca ? 'Nenhuma simulação encontrada.' : 'Nenhuma simulação salva ainda. Faça uma simulação e clique em "Salvar".'}
                </td>
              </tr>
            )}
            {filtered.map((sim) => {
              const clientName = getClientName(sim.clientId);
              const cor = getColor(clientName);
              const iniciais = getIniciais(clientName);
              const bancos = sim.bancos || [];
              const melhor = sim.melhorBanco;

              return (
                <tr key={sim.id} style={{ cursor: 'pointer' }}>
                  <td style={tdStyle}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <div style={{
                        width: 32, height: 32, borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: '0.65rem', fontWeight: 700, color: '#fff', background: cor, flexShrink: 0,
                      }}>{iniciais}</div>
                      <div>
                        <div style={{ fontWeight: 600 }}>{clientName}</div>
                        {!sim.clientId && (
                          <div style={{ fontSize: '0.68rem', color: 'var(--text-muted)' }}>Avulsa</div>
                        )}
                      </div>
                    </div>
                  </td>
                  <td style={{ ...tdStyle, fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}>
                    {sim.valorFinanciado || '—'}
                  </td>
                  <td style={tdStyle}>{sim.prazo ? `${sim.prazo} meses` : '—'}</td>
                  <td style={tdStyle}>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      {bancos.map((b) => (
                        <span key={b.nome} style={{
                          fontSize: '0.6rem', fontWeight: 600, padding: '3px 7px', borderRadius: 4,
                          color: '#fff', background: b.cor || '#666',
                        }}>{b.nome}</span>
                      ))}
                    </div>
                  </td>
                  <td style={tdStyle}>
                    {melhor ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <div style={{ width: 6, height: 6, borderRadius: '50%', background: melhor.cor || 'var(--accent)' }} />
                        <span style={{ fontSize: '0.78rem', fontWeight: 600 }}>{melhor.nome}</span>
                      </div>
                    ) : '—'}
                  </td>
                  <td style={{ ...tdStyle, fontSize: '0.78rem', color: 'var(--text-muted)' }}>
                    {formatDate(sim.criadoEm)}
                  </td>
                  <td style={tdStyle}>
                    <div style={{ display: 'flex', gap: 4 }}>
                      {sim.clientId && (
                        <button
                          onClick={() => navigate('/simulador', { state: { clienteId: sim.clientId } })}
                          title="Re-simular"
                          style={{
                            width: 28, height: 28, borderRadius: 6, border: '1px solid var(--border)',
                            background: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: '0.72rem', cursor: 'pointer',
                          }}
                        >⚡</button>
                      )}
                      <button
                        onClick={() => handleDelete(sim.id)}
                        title="Excluir"
                        style={{
                          width: 28, height: 28, borderRadius: 6, border: '1px solid var(--border)',
                          background: 'var(--white)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                          fontSize: '0.72rem', cursor: 'pointer',
                        }}
                      >🗑️</button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
      </Card>
    </>
  );
}